export enum Requests {
  Get = 'GET',
  Put = 'PUT',
  Patch = 'PATCH',
  Post = 'POST',
  Delete = 'DELETE',
}
